import React from "react";
import { IIcons } from "./icons";

const RemitterIconNew = ({ fillColor }: IIcons.IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
    <ellipse cx="9.58765" cy="6.36625" rx="5.4314" ry="5.79349" fill={fillColor || "#0F5BF1"} />
    <ellipse cx="9.5914" cy="18.6776" rx="9.05233" ry="4.34512" fill={fillColor || "#0F5BF1"} />
  </svg>
);
export default RemitterIconNew;
